angular.module("angus.controllers").controller("inventoryTransactionReportController", [
  "$rootScope", "$scope", "_", "dealerService", "drillService", "gridService2", "gridState", "productsService", "subscriberService", "inventoryService", "constantsService", "$q",
  function($rootScope, $scope, _, dealerService, drillService, gridService2, gridState, productsService, subscriberService, inventoryService, constantsService, $q) {
    "use strict";

    const userSubscriberKey = $rootScope.user.subscriberAbosKey;
    $scope.subscriberId = $rootScope.user.subscriberId;
    $scope.isSysAdmin = !!$rootScope.user.isSysAdmin;

    $scope.transactionTypes = _.map(constantsService.transactionTypes.enums, function(transactionType) {
      return {
        name: transactionType.value.display,
        key: transactionType.value.id
      };
    });

    /* Default Filter Values - Start/End Date default to the last 3 months */
    const today = new Date();
    $scope.settings = {
      startDate: new Date(today.getFullYear(), today.getMonth() - 3, today.getDate()),
      endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
    };

    $scope.runReport = runReport;

    /* Need to use the watch to support the user selecting a saved filter */
    $scope.$watch("settings.selectedSubscriber", () => {
      /* Reload Subscriber Specific Assets */
      loadProducts();
    });

    /* If the user changes the Subscriber then Reset then Subscriber Specific selections.
        The reloading of the assets will be handled in the selectedSubscriberId watch */
    $scope.subscriberChanged = () => {
      $scope.settings.productCategoryIds = [];
    };

    /* Initialize Subscribers and Grid */

    if (!$scope.isSysAdmin) {
      $scope.settings.selectedSubscriber = {};
      $scope.settings.selectedSubscriber.subscriberKey = userSubscriberKey;
    }

    const subscribersPromise = $scope.isSysAdmin ? loadSubscribers() : $q.when();

    subscribersPromise
      .then(function() {
        const gridParams = {
          gridState: gridState($scope.subscriberId, $scope.widgetCode),
          defs: getColDefs(),
          exportOptions: { fileName: "Inventory Transaction" },
          gridOptions: {
            groupAggFunction: (rows) => undefined
          }
        };

        return gridService2.createGrid(gridParams);
      })
      .then(function(grid) {
        grid.setRows(Promise.resolve());

        $scope.grid = grid;
      })
      .catch(function(error) {
        console.log(error);
      });


    function loadSubscribers() {
      $scope.areSubscribersLoading = true;

      return subscriberService.getAllLive()
        .then(function(subscribers) {
          $scope.subscribers = subscribers;
          $scope.areSubscribersLoading = false;
        });
    }

    function loadProducts() {
      if (!$scope.settings.selectedSubscriber) {
        return;
      }

      $scope.areProductsLoading = true;
      $scope.settings.productCategoryKeys = [];

      return productsService
        .getProducts($scope.settings.selectedSubscriber.externalSubscriberId)
        .then(function(products) {
          $scope.products = products;
          $scope.areProductsLoading = false;
        });
    }

    function getColDefs() {
      const colDefs = [];

      colDefs.push(gridService2.colDef.createText("transactionId", "Transaction No", "transactionId"));

      colDefs.push(gridService2.colDef.createDateNG(
        "transactionDate",
        "Transaction Date",
        "transactionDate",
        {sort: "desc" }
      ));

      colDefs.push(gridService2.colDef.createText("vendorName", "Vendor Name", "vendorName"));

      colDefs.push(gridService2.colDef.createText("vendorLocationName", "Vendor Location Name", "vendorLocationName"));

      colDefs.push(gridService2.colDef.createText("lineDescription", "Transaction Description", "lineDescription"));

      colDefs.push(gridService2.colDef.createText("lineId", "Transaction Line Id", "lineId"));

      colDefs.push(gridService2.colDef.createBoolean(
        "isContract",
        "Contract",
        "isContract"
      ));

      colDefs.push(gridService2.colDef.createNumber(
        "unitsGross",
        "Units Gross",
        "unitsGross",
        {},
        { decimalPlaces: 0 }
      ));

      colDefs.push(gridService2.colDef.createNumber(
        "unitsNet",
        "Units Net",
        "unitsNet",
        {},
        { decimalPlaces: 0 }
      ));

      colDefs.push(gridService2.colDef.createNumber(
        "unitCost",
        "Unit Cost",
        "unitCost",
        {},
        { decimalPlaces: 4 }
      ));

      colDefs.push(gridService2.colDef.createNumber(
        "extendedCost",
        "Extended Cost",
        "extendedCost",
        {},
        { decimalPlaces: 2 }
      ));

      colDefs.push(gridService2.colDef.createText(
        "sourceProductName",
        "Product Name (Source)",
        "sourceProductName"
      ));

      /* Displays the BRITE Product; the shared usp_InventoryTransaction_Select returns product values in this column (ref 2986) */
      colDefs.push(gridService2.colDef.createText(
        "productName",
        "Product",
        "productName"
      ));

      colDefs.push(gridService2.colDef.createText(
        "sourceProductDesc",
        "Product Description (Source)",
        "sourceProductDesc"
      ));

      colDefs.push(gridService2.colDef.createText(
        "productCategoryCostName",
        "Product Cost Category",
        "productCategoryCostName"
      ));

      colDefs.push(gridService2.colDef.createText(
        "transactionTypeName",
        "Transaction Type",
        "transactionTypeName"
      ));

      colDefs.push(gridService2.colDef.createText(
        "inventoryLocationId",
        "Location Id",
        "inventoryLocationId"
      ));

      colDefs.push(gridService2.colDef.createText(
        "inventoryLocationName",
        "Location Name",
        "inventoryLocationName"
      ));
      return colDefs;
    }

    function runReport() {
      const settings = $scope.settings;
      if (!settings.selectedSubscriber.subscriberKey || !settings.startDate || !settings.endDate) {
        return;
      }

      const params = {
        startDate: settings.startDate.toISOString().split("T")[0],
        endDate: settings.endDate.toISOString().split("T")[0],
        productCategoryReportKeys: settings.productCategoryKeys,
        inventoryTransactionTypeKeys: settings.inventoryTransactionTypeKeys,
        useCompactColumns: false
      };

      var dataPromise = inventoryService.postInventoryTransactionReport(settings.selectedSubscriber.subscriberKey, params)
        .then(data => {

          return data.data;
        });

      var promise = $scope.grid.setRows(dataPromise);

      return promise;
    }

  }

]);